// Etiquetas de `Etiqueta` que afectan el orden. El resto se muestra tal cual.

export const PRIORITY_TAGS = ['PRIORIDAD ALTA', 'PRIORIDAD MEDIA', 'PRIORIDAD BAJA'] as const;

/** Rango para tarjetas sin etiqueta de prioridad: van después de BAJA. */
export const NO_PRIORITY_RANK: number = PRIORITY_TAGS.length;

function tagKey(tag: string): string {
  return tag.normalize('NFC').replace(/\s+/g, ' ').trim().toUpperCase();
}

const RANK_BY_KEY = new Map<string, number>(PRIORITY_TAGS.map((t, i) => [tagKey(t), i]));

/** Si una tarjeta tiene varias prioridades, gana la más alta. */
export function priorityRank(etiquetas: readonly string[]): number {
  let best = NO_PRIORITY_RANK;
  for (const tag of etiquetas) {
    const rank = RANK_BY_KEY.get(tagKey(tag));
    if (rank !== undefined && rank < best) best = rank;
  }
  return best;
}

export function isPriorityTag(tag: string): boolean {
  return RANK_BY_KEY.has(tagKey(tag));
}
